module.exports = __webpack_public_path__ + "img/label-10DUPLO.c9b3eea4.jpeg";